import { useCallback } from 'react'
import { useHistory, useParams } from '../Router'
import { useAppDispatch } from '../store/hooks'
import { setError } from './store'
import { Sentry } from '../Sentry'

export function useShowError() {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const { establishmentId } = useParams<{ [key: string]: string }>()

  return useCallback(
    (context: string, error?: Error | string, message?: string) => {
      Sentry.captureException(
        error instanceof Error ? error : new Error(String(error || context)),
        { tags: { context } },
      )
      dispatch(setError(context, error, message))
      history.push(`/${establishmentId}/error`)
    },
    [dispatch, history, establishmentId],
  )
}
